module.exports = __webpack_public_path__ + "static/media/AJ_JPP3.fcddc66e.jpg";